/**
 * Normalizes body part names to handle legacy data inconsistencies
 * This ensures consistent filtering across the application
 */

export const normalizeBodyPart = (bodyPart) => {
  if (!bodyPart) return bodyPart;
  
  // Handle legacy naming inconsistencies
  const normalizationMap = {
    "Chest/Stomach": "Chest & Stomach",
    "Teaser Photos": "Teaser",
    // Add more mappings as needed for other legacy formats
  };

  return normalizationMap[bodyPart] || bodyPart;
};

/**
 * Gets all possible body part values (normalized)
 * Used for consistent filtering across components
 */
export const getAllBodyParts = () => [
  "All Photos",
  "Profile Picture", 
  "Teaser",
  "Full Body",
  "Chest & Stomach",
  "Butt",
  "P/V",
  "Legs",
  "Feet"
];

/**
 * Checks if two body parts are equivalent (handles normalization)
 */
export const areBodyPartsEqual = (bodyPart1, bodyPart2) => {
  return normalizeBodyPart(bodyPart1) === normalizeBodyPart(bodyPart2);
};
